import { useMemo } from 'react';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import useMedicalProvidersInputMode from './useMedicalProvidersInputMode';
import { getIsSectionPendingAiResolution, selectRenderableProviders } from '../utils/medicalProviderHelpers';

/**
 * Derives the editable provider cards for a timing section and whether they
 * should be locked. Editing is locked only in AI mode while the ingestion
 * bucket still holds files awaiting resolution.
 * @param {Object} params
 * @param {string} params.providerType - the timing section key (e.g. postAccident)
 * @returns {{ providers: Array<{ provider: Object, providerIndex: number }>, isLocked: boolean }}
 */
const useMedicalProviderList = ({ providerType }) => {
  const { formik, selectedTiffIndex } = useAddCaseFormContext();
  const { isAiMode } = useMedicalProvidersInputMode();

  const medicalRecords = formik.values?.clients?.[selectedTiffIndex]?.medicalProviders?.[providerType]?.medicalRecords;

  return useMemo(() => ({
    providers: selectRenderableProviders(medicalRecords),
    isLocked: getIsSectionPendingAiResolution({ medicalRecords, isAiMode })
  }), [medicalRecords, isAiMode]);
};

export default useMedicalProviderList;
